export default {
  number: 'v2.3.8',
}
